<script>
import { orderBy, assign, first } from 'lodash';

import NuttremaIndexVirtualGroupList from 'components/ui/list/nuttrema-index-virtual-group-list';
import NuttremaIndexListItem from './cmpt-instance-subscriptions-list-item';

export default {
  mixins: [NuttremaIndexVirtualGroupList],
  name: 'cmpt-instance-subscriptions-list',
  components: {
    NuttremaIndexListItem,
  },
  props: {
    features: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    monitored() {
      return this.state;
    },
  },
  methods: {
    order() {
      switch (this.sorting.selected.key) {
        case 'status':
          return orderBy(this.state, [item => item.status], [this.orders.selected]);
        case 'name':
          return orderBy(this.state, [item => item.name], [this.orders.selected]);
        default:
          return orderBy(this.state, [item => new Date(item.name)], [this.orders.selected]);
      }
    },
  },
  created() {
    const groupingList = [
      { label: 'label.status', type: 'property', key: 'status' },
    ];
    const sortingList = [
      { label: 'label.name', key: 'name' },
      { label: 'label.status', key: 'status' },
    ];
    assign(this.grouping, {
      list: groupingList,
      selected: first(groupingList),
    });
    assign(this.sorting, {
      list: sortingList,
      selected: first(sortingList),
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/instance-subscriptions/list/cmpt-instance-subscriptions-list.vue